var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_34165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2626 0.718628V6.77007H30.355L24.2626 0.718628Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2056 13.7083H24.082V16.9961H12.2056V13.7083Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0785 33.0947V9.23098H23.032C22.3528 9.23098 21.8016 8.68055 21.8016 8.00051V0H8.41899C6.64875 0 5.20911 1.43391 5.20911 3.19676V33.0947C5.20911 34.8567 6.64875 36.2914 8.41899 36.2914H27.8678C29.6388 36.2914 31.0785 34.8567 31.0785 33.0947ZM16.2956 32.1284H10.9751C10.2959 32.1284 9.74461 31.5779 9.74461 30.8979C9.74461 30.2187 10.2959 29.6674 10.9751 29.6674H16.2956C16.9748 29.6674 17.5261 30.2187 17.5261 30.8979C17.5261 31.5779 16.9748 32.1284 16.2956 32.1284ZM25.3125 28.0268H10.9751C10.2959 28.0268 9.74461 27.4764 9.74461 26.7963C9.74461 26.1171 10.2959 25.5659 10.9751 25.5659H25.3125C25.9917 25.5659 26.543 26.1171 26.543 26.7963C26.543 27.4764 25.9917 28.0268 25.3125 28.0268ZM9.74461 22.6948C9.74461 22.0155 10.2959 21.4643 10.9751 21.4643H23.306C23.9852 21.4643 24.5365 22.0155 24.5365 22.6948C24.5365 23.3748 23.9852 23.9252 23.306 23.9252H10.9751C10.2959 23.9252 9.74461 23.3748 9.74461 22.6948ZM26.543 18.2265C26.543 18.9066 25.9917 19.457 25.3125 19.457H10.9751C10.2959 19.457 9.74461 18.9066 9.74461 18.2265V12.4778C9.74461 11.7977 10.2959 11.2473 10.9751 11.2473H25.3125C25.9917 11.2473 26.543 11.7977 26.543 12.4778V18.2265Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5412 13.4652H33.5394V33.2497C33.5394 36.2887 31.0759 38.7522 28.0369 38.7522H11.4618V38.8031C11.4618 40.5658 12.902 41.9999 14.6723 41.9999H33.5803C35.3506 41.9999 36.7908 40.5659 36.7908 38.8031V16.7041C36.7908 14.9181 35.3331 13.4652 33.5412 13.4652Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_34165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.4550947744daea827de3acbda840961f.svg";
export { ForwardRef as ReactComponent };